import dynamic from 'next/dynamic'
import {
    FORM_SUBMITTED_EVENT,
    HTML_CONTENT_ID,
    TABLET_WIDTH
} from '../constants/post_page'
import Script from 'next/script'
import ReactDOMServer from 'react-dom/server'
import { ThankYouPage } from '@App/libs/components/rdstationThankYouPage'
import {
    SponsorBy,
    SponsorImage,
    SponsorImageContainer,
    SponsorParagraph,
    SponsorRoot
} from '@App/libs/style/post-page'
import { companyRelationQuoteEnum, generateUUID, vercelLog } from '../geral'
import { wpPostType } from '@App/libs/model/post-wp'
import { BreadcrumbPathInfo } from '@App/libs/components/ds/Breadcrumb/interfaces'
import { insertPostCTA, PostCTAType } from './post-cta.utils'

// Injeta o formulário RD Staion na versão mobile abaixo do primeiro parágrafo
export const rdMobileForm = (
    firstParagraph: HTMLElement,
    RD_STATION_FORM_ID: string
) => {
    const formDiv = document.createElement('div')
    formDiv.setAttribute('id', RD_STATION_FORM_ID)
    formDiv.setAttribute('class', 'rd-station-form')

    firstParagraph.after(formDiv)
}
interface GetBodyLastParagraphParams {
    node: any
    showIcon: boolean
    setShowIcon: (value: boolean) => void
    formHasBeenCreated: boolean
    setFormHasBeenCreated: (value: boolean) => void
    RD_STATION_FORM_ID: string
    rdMobileForm: (firstParagraph: HTMLElement) => void
    cta?: PostCTAType
}
export const getBodyLastParagraph = ({
    node,
    showIcon,
    setShowIcon,
    formHasBeenCreated,
    setFormHasBeenCreated,
    RD_STATION_FORM_ID,
    rdMobileForm,
    cta
}: GetBodyLastParagraphParams) => {
    // EX-4105: tratando imagens e tags no post
    node.querySelectorAll('img').forEach((img: HTMLImageElement) => {
        img.src = img.src.replace(
            'https://www.jota.info/wp-content/uploads/',
            'https://images.jota.info/wp-content/uploads/'
        )

        img.src = img.src.replace(
            'https://portal.jota.info/wp-content/uploads/',
            'https://images.jota.info/wp-content/uploads/'
        )

        img.srcset = img.srcset.replace(
            'https://www.jota.info/wp-content/uploads/',
            'https://images.jota.info/wp-content/uploads/'
        )

        img.srcset = img.srcset.replace(
            'https://portal.jota.info/wp-content/uploads/',
            'https://images.jota.info/wp-content/uploads/'
        )
    })
    node.innerHTML = node.innerHTML.replaceAll(/\[caption[^\]]*\]/g, '')
    node.innerHTML = node.innerHTML.replaceAll('[/caption]', '')

    const nodeChildrenList = [...node.children]
    const nodeChildrenListWithoutNotes = nodeChildrenList.filter((children) => {
        return children.className !== 'notas-rodape'
    }) as HTMLElement[]
    const lastParagraph = nodeChildrenListWithoutNotes?.at(-1)

    if (!showIcon) {
        appendIconToLastParagraph(node, lastParagraph)
        setShowIcon(true)
    }

    // CTA APÓS O 2º PARÁGRAFO
    const paragraphElements = nodeChildrenListWithoutNotes.filter(
        (child) => child.tagName === 'P'
    )

    insertPostCTA(paragraphElements, cta)

    // FORMULÁRIO RD STATION
    const alreadyHasForm = document.getElementById(RD_STATION_FORM_ID)
    const firstParagraph = node.querySelector('p') as HTMLElement | null
    const isMobile = globalThis.window.innerWidth < TABLET_WIDTH

    if (isMobile && firstParagraph && !alreadyHasForm && !formHasBeenCreated) {
        rdMobileForm(firstParagraph)
        setFormHasBeenCreated(true)
    }
}

const appendIconToLastParagraph = (node: any, lastParagraph: any) => {
    const icon = node.getRootNode() as Document
    const JotinhaIcon = icon.createElement('img')
    JotinhaIcon.src = '/images/favicon.svg'
    JotinhaIcon.id = 'jotinha'
    JotinhaIcon.alt = 'logo-jota'
    if (lastParagraph) lastParagraph.appendChild(JotinhaIcon)
}

/**
 * Converte shortcodes [embed] em elementos <iframe> válidos para renderização no React.
 *
 * - Remove tags [embed] que envolvem diretamente um <iframe>
 * - Converte [embed]URL[/embed] em <iframe> de YouTube ou Spotify
 * - Links desconhecidos viram <a>
 *
 * @param {string} html - O conteúdo HTML contendo shortcodes [embed]
 * @return {string} O HTML com iframes convertidos, pronto para renderização no React
 */
export function convertEmbedsToIframes(html: string): string {
    html = html.replaceAll(/\[\/?embed\](?=\s*<iframe)/g, '')

    html = html.replaceAll(/\[embed\](.*?)\[\/embed\]/g, (match, url) => {
        const trimmedUrl = url.trim()

        if (
            trimmedUrl.includes('youtube.com') ||
            trimmedUrl.includes('youtu.be')
        ) {
            const videoId = (() => {
                try {
                    return trimmedUrl.includes('youtube.com')
                        ? new URL(trimmedUrl).searchParams.get('v')
                        : trimmedUrl.split('/').pop()
                } catch {
                    return null
                }
            })()

            if (videoId) {
                return `<iframe width="100%" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`
            }
        }

        if (trimmedUrl.includes('spotify.com')) {
            const path = trimmedUrl.split('spotify.com/')[1]?.trim()

            if (path) {
                return (
                    `<iframe src="https://open.spotify.com/embed/${path}" width="100%" height="152" ` +
                    `frameborder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>`
                )
            }
        }
        // Valida que é http/https antes de retornar o link
        const safeUrl = (() => {
            try {
                const parsed = new URL(trimmedUrl)
                if (!['http:', 'https:'].includes(parsed.protocol)) return null
                return parsed.href
            } catch {
                return null
            }
        })()

        if (!safeUrl) return ''
        return `<a href="${trimmedUrl}" target="_blank" rel="noopener noreferrer">${trimmedUrl}</a>`
    })

    return html
}

const createScriptComponent = (id: string, src: string) =>
    dynamic(
        () =>
            Promise.resolve(() => (
                <Script id={id} src={src} strategy='lazyOnload' />
            )),
        { ssr: false }
    )
export const TwitterScript = createScriptComponent(
    'TwitterAPI',
    'https://platform.twitter.com/widgets.js'
)
export const InstagramScript = createScriptComponent(
    'InstagramAPI',
    '//www.instagram.com/embed.js'
)
export const TikTokScript = createScriptComponent(
    'TikTokAPI',
    'https://www.tiktok.com/embed.js'
)

interface HandleFormSubmitParams {
    FORM_TAG_ID: string
    RD_STATION_FORM_ID: string
    setIsSuccess: (value: boolean) => void
    injectMobileThankYouMessage: (firstParagraph: HTMLElement) => void
}
export const handleFormSubmitClick = ({
    FORM_TAG_ID,
    RD_STATION_FORM_ID,
    setIsSuccess,
    injectMobileThankYouMessage
}: HandleFormSubmitParams) => {
    const form = document.querySelector(`#${FORM_TAG_ID}`) as HTMLFormElement
    const emailInput = form?.querySelector(
        'input[type="email"]'
    ) as HTMLInputElement
    const nameInput = form?.querySelector(
        'input[name*="name"], input[name*="Nome"]'
    ) as HTMLInputElement

    if (emailInput?.value && emailInput.checkValidity()) {
        setTimeout(() => {
            const eventPayload = {
                event: FORM_SUBMITTED_EVENT,
                form_id: RD_STATION_FORM_ID,
                email: emailInput.value,
                name: nameInput?.value || '',
                event_category: 'engagement',
                event_action: 'form_submission',
                event_label: 'rd_station_form'
            }

            globalThis.window.dataLayer?.push(eventPayload)

            const successEvent = new CustomEvent(FORM_SUBMITTED_EVENT, {
                detail: {
                    RD_STATION_FORM_ID,
                    email: emailInput.value,
                    name: nameInput?.value
                }
            })

            globalThis.window.dispatchEvent(successEvent)
        }, 2000)

        setIsSuccess(true)
        const isMobile = globalThis.window.innerWidth < TABLET_WIDTH
        if (isMobile) {
            const firstParagraph = document.querySelector('p')
            const formContainer = document.getElementById(RD_STATION_FORM_ID)

            if (formContainer) {
                formContainer.remove()
            }
            if (firstParagraph) {
                injectMobileThankYouMessage(firstParagraph)
            }
        } else {
            const formBody = document.getElementById(
                `form-${RD_STATION_FORM_ID}`
            ) as HTMLFormElement | null
            if (formBody) {
                formBody.style.display = 'none'
            }
        }
    } else {
        vercelLog(' Form validation failed')
    }
}

export const formatNumbers = (number: any) => {
    return number < 10 ? `0${number}` : number
}

export const updateContainer = (
    date: Date | undefined,
    dateRecent: Date | undefined
) => {
    if (!date || !dateRecent) return false

    return (
        date.getDate() !== dateRecent.getDate() ||
        date.getMonth() !== dateRecent.getMonth() ||
        date.getFullYear() !== dateRecent.getFullYear() ||
        date.getHours() !== dateRecent.getHours() ||
        date.getMinutes() !== dateRecent.getMinutes()
    )
}

/**
 *Align RD Station box
 * @param {string} RD_STATION_FORM_ID - ID do formulário RD Station
 * @return {void}
 */
export function alignRDBOX(RD_STATION_FORM_ID: string): void {
    const contentHTMLText = document.querySelector<HTMLElement>(HTML_CONTENT_ID)
    const RDStationBOX = document.getElementById(RD_STATION_FORM_ID)
    if (!contentHTMLText || !RDStationBOX) return

    RDStationBOX.style.position = 'absolute'

    const op =
        (RDStationBOX.offsetParent as HTMLElement) || document.documentElement
    const r = contentHTMLText.getBoundingClientRect()
    const rp = op.getBoundingClientRect()

    RDStationBOX.style.top = `${r.top - rp.top + op.scrollTop}px`
}

// Injeta o Thank You page na versão mobile abaixo do primeiro parágrafo
export const injectMobileThankYouMessage = (firstParagraph: HTMLElement) => {
    const thankYouDiv = document.createElement('div')
    thankYouDiv.setAttribute('class', 'rd-station-form thankyoupage')

    thankYouDiv.innerHTML = ReactDOMServer.renderToString(<ThankYouPage />)

    firstParagraph.after(thankYouDiv)
}

/**
 * Show Sponsored Logos
 * Description: Priority
 * 1 - post is sponsored
 * 2 - post is from a subcategory of 'Coberturas Especiais'
 * 3 - post category is sponsored
 * @description Show the sponsored logos
 * @param {wpPostType} post
 * @param {'object' | 'disclaimer'} output
 * @param {React.RefObject<HTMLDivElement>} [sponsorRef] - Ref do container do patrocinador
 * @return {JSX.Element | null}
 */
export const showSponsoredLogos = (
    post: wpPostType,
    output: 'object' | 'disclaimer' = 'object',
    sponsorRef?: React.RefObject<HTMLDivElement>
): JSX.Element | null => {
    const sponsorData: {
        relation: string
        logo: string | string[]
        disclaimer: string
    } = {
        relation: '',
        logo: '',
        disclaimer: ''
    }

    // 1 - post is sponsored
    if (post.sponsor.by_post?.name) {
        sponsorData.relation = post.sponsor.by_post.name
        sponsorData.logo = post.sponsor.by_post.logo
        sponsorData.disclaimer = post.sponsor.by_post.description
    }

    // 2 - post is from a subcategory of 'Coberturas Especiais'
    else if (post.coberturasEspeciais?.disclaimer) {
        sponsorData.relation =
            companyRelationQuoteEnum[
                post?.coberturasEspeciais
                    ?.relation_type as keyof typeof companyRelationQuoteEnum
            ]
        sponsorData.logo = post.coberturasEspeciais?.company_logo ?? ''
        sponsorData.disclaimer = post.coberturasEspeciais?.disclaimer ?? ''
    }

    // 3 - post category is sponsored
    else if (post.sponsor.by_category?.name) {
        sponsorData.relation = post.sponsor.by_category.name
        sponsorData.logo = post.sponsor.by_category.logos
        sponsorData.disclaimer = post.sponsor.by_category.description
    } else {
        return null
    }

    if (output === 'disclaimer') {
        return <SponsorParagraph>{sponsorData.disclaimer}</SponsorParagraph>
    }

    return (
        <SponsorRoot ref={sponsorRef}>
            <SponsorBy>{sponsorData.relation}</SponsorBy>
            <SponsorImageContainer>
                {typeof sponsorData.logo === 'string' ? (
                    <SponsorImage
                        src={sponsorData.logo}
                        alt={'Logo do patrocinador'}
                        width={'100%'}
                    />
                ) : (
                    sponsorData.logo?.map((logo: string) => {
                        return (
                            <SponsorImage
                                key={generateUUID()}
                                src={logo}
                                alt={'Logo do patrocinador'}
                                width={'100%'}
                            />
                        )
                    })
                )}
            </SponsorImageContainer>
        </SponsorRoot>
    )
}

export const buildPathInfo = (
    post: wpPostType,
    firstSegment?: { name: string; slug: string } | null
): BreadcrumbPathInfo => {
    const pathInfo: BreadcrumbPathInfo = {
        pageName: '',
        firstSegmentName: firstSegment?.name || null,
        firstSegmentSlug: firstSegment?.slug || null,
        parentName: '',
        parentSlug: '',
        childName: null,
        childSlug: null
    }

    const breadcrumbFromApi = post.breadcrumbs[0]

    if (breadcrumbFromApi) {
        pathInfo.parentName =
            breadcrumbFromApi.title || breadcrumbFromApi.children.title
        pathInfo.parentSlug =
            breadcrumbFromApi.slug || breadcrumbFromApi.children.slug
        pathInfo.childName =
            breadcrumbFromApi.children.title == breadcrumbFromApi.title
                ? null
                : breadcrumbFromApi.children.title
        pathInfo.childSlug =
            breadcrumbFromApi.children.slug == breadcrumbFromApi.slug
                ? null
                : breadcrumbFromApi.children.slug
    }

    return pathInfo
}

export const formatPostDate = (
    date: Date | undefined,
    separator = '|'
): string => {
    if (!date) return ''

    const day = formatNumbers(date.getDate())
    const month = formatNumbers(date.getMonth() + 1)
    const year = date.getFullYear()
    const hours = formatNumbers(date.getHours())
    const minutes = formatNumbers(date.getMinutes())

    return `${day}/${month}/${year} ${separator} ${hours}:${minutes}`
}
